import React from 'react'
import { observer } from 'mobx-react-lite'
import CampaignScenariosProjectAsset from '../../../../../../models/CampaignScenariosProjectAsset'
import ProjectTimelineAssetItem from '../../../../../Shared/TimelineParts/ProjectTimelineAssetItem'
import ScenarioTimelineAssetItem from '../../../../../Shared/TimelineParts/ScenarioTimelineAssetItem'

export default observer(function TimelineAssetItem({ timelineAsset }) {
  const isTemporary = String(timelineAsset.id).startsWith('temp-')

  const isProjectAsset = timelineAsset instanceof CampaignScenariosProjectAsset

  if (!isProjectAsset) {
    return (
      <ScenarioTimelineAssetItem
        timelineAsset={timelineAsset}
        isTemporary={isTemporary}
      />
    )
  }

  return (
    <ProjectTimelineAssetItem
      timelineAsset={timelineAsset}
      isTemporary={isTemporary}
    />
  )
})